export default __webpack_public_path__ + "static/media/Miyobeehi.b7467b73.png";